import React, { Component } from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Column from '~/Common-Objects/Grids/Column/Column'
import Icons from '~/Common-Objects/UI/Icons/index'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import { connect } from 'react-redux'
import i18n from '~/i18n'
import TemplateImageLoader from '~/pages/cp/automation/addNew/templateImageLoader.jsx'
import helpers from '~/Classes/helpers'
@connect((store) => {
    return { accountMaster: store.accountMaster }
})
class FormConfirm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            errors: {}
        }
        this.updateField = this.updateField.bind(this)
        this.checkForm = this.checkForm.bind(this)
        this.edit = this.edit.bind(this)
        this.next = this.next.bind(this)
    }

    componentDidMount() {
        this.checkForm()
    }

    updateField(ev, options) {
        var form = this.props.form
        if (options) {
            form.options[ev.currentTarget.name] = ev.currentTarget.value
        } else {
            form[ev.currentTarget.name] = ev.currentTarget.value
        }
        this.checkForm()
        this.props.update()
    }

    checkForm() {
        var errors = {}
        var options = this.props.form.options

        if (options.onConfirm === 'redirect') {
            if (!options.confirmedRedirectUrl) {
                errors.confirmedRedirectUrl = i18n.t('form:step5.errUrl')
            } else if (
                options.confirmedRedirectUrl.toLowerCase().indexOf('http://') < 0 &&
                options.confirmedRedirectUrl.toLowerCase().indexOf('https://') < 0
            ) {
                errors.confirmedRedirectUrl = i18n.t('form:step5.errUrlHttp')
            }
        }
        this.setState({
            errors
        })
    }

    async edit() {
        const isUsingNewEditor = await helpers.getTemplateEditorVersion(this.props.accountMaster, true)
        this.props.save().then(() => {
            var redirect = '/cp/groups/' + this.props.groupId + '/forms/create/' + this.props.form.id + '/6'
            const editorUrl = isUsingNewEditor.canUseV2
                ? '/cp/templates/add/dragDropv2/'
                : '/cp/templates/add/dragDrop/'

            this.props.history.push(
                editorUrl +
                    '?form=false&groupId=' +
                    this.props.groupId +
                    '&formId=' +
                    this.props.form.id +
                    '&page=confirmed&redirect=' +
                    redirect
            )
        })
    }

    next() {
        this.props.form.wizard.step5 = true
        this.props.update()
        if (this.props.form.options.onConfirm === 'landing') {
            this.edit()
        } else {
            this.props.changeStep(6, true)
        }
    }

    render() {
        return (
            <div>
                <Row>
                    <Column xs={12} md={4} className='mar-b25'>
                        <div
                            className='campaign-thumbnail'
                            style={{ width: '100%', height: '100%', minHeight: '150px' }}
                        >
                            <TemplateImageLoader
                                imageUrl={this.props.screenshotUrl}
                                form={this.props.form.formType === 1}
                            />
                        </div>
                    </Column>
                    <Column xs={12} md={8}>
                        <Paper>
                            <h4 className='mar-b25'>
                                {this.props.form.options?.serve === 'emailLanding'
                                    ? 'You must have a landing page to show the file downloads'
                                    : i18n.t('form:step5.header')}
                            </h4>

                            <Select
                                outerClassName='mar-b25'
                                name='onConfirm'
                                value={this.props.form.options.onConfirm}
                                data={[
                                    { label: i18n.t('form:step5.landing'), value: 'landing' },
                                    {
                                        label: i18n.t('form:step5.redirect'),
                                        value: 'redirect',
                                        disabled: this.props.form.options?.serve === 'emailLanding'
                                    }
                                ]}
                                onChange={(ev) => this.updateField(ev, true)}
                            />

                            {this.props.form.options.onConfirm !== 'landing' && (
                                <TextInput
                                    outerClassName='mar-b25'
                                    value={this.props.form.options.confirmedRedirectUrl}
                                    error={this.state.errors.confirmedRedirectUrl}
                                    placeholder='redirect url'
                                    name='confirmedRedirectUrl'
                                    onChange={(ev) => this.updateField(ev, true)}
                                />
                            )}
                        </Paper>
                    </Column>
                </Row>
                <div className='quickFlex end-xs'>
                    <Button
                        iconRight={<Icons icon='arrowRight' />}
                        className='button-primary'
                        disabled={!!Object.keys(this.state.errors).length}
                        text={
                            this.props.form.options.onConfirm === 'landing'
                                ? i18n.t('form:step5.design')
                                : i18n.t('form:step5.next')
                        }
                        onClick={this.next}
                    />
                </div>
            </div>
        )
    }
}

export default FormConfirm
